export default __webpack_public_path__ + "static/media/performance-icon.71abe8b7.png";